const PREFIX = 'PHYSICIAN_REFERRAL';

// eslint-disable-next-line import-x/prefer-default-export
export const CREATE_PHYSICIAN_REFERRAL = `${PREFIX}/CREATE`;
export const SET_SHOW_THANK_YOU_PAGE = `${PREFIX}/SET_SHOW_THANK_YOU_PAGE`;
